module.exports = __webpack_public_path__ + "img/34.ab9409ab.jpg";